// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Accordion-module__Container__TxxsK {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.Accordion-module__HeaderContainer__FfwPB {
    width: 100%;
    border-radius: var(--ds-border-radius-s);
}

.Accordion-module__HeaderClickable__cek9U {
    cursor: pointer;
}

.Accordion-module__HeaderContainerDisabled__XnlWa {
    cursor: default;
}

.Accordion-module__HeaderContainer__FfwPB:focus-visible {
    outline: 1px solid var(--ds-color-grey-20);
}

.Accordion-module__Panel__zHBu2 {
    /* Single-row grid: animating 0fr <-> 1fr interpolates to the content height */
    display: grid;
    padding: 0 var(--ds-s);
    overflow: hidden;
}

.Accordion-module__PanelContent__m1ZDd {
    /* Lets the grid item shrink below its content size */
    min-height: 0;
}

.Accordion-module__PanelCollapsed__iZUIX {
    grid-template-rows: 0fr;
    visibility: hidden;
    transition:
        grid-template-rows var(--ds-transition-s) ease-out,
        visibility var(--ds-transition-s) step-end,
        padding-top var(--ds-transition-s) step-end;
}

.Accordion-module__PanelExpanded__mQMop {
    grid-template-rows: 1fr;
    padding-top: var(--ds-s);
    visibility: visible;
    transition: grid-template-rows var(--ds-transition-s) ease-in;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Accordion-module__Container__TxxsK`,
	"HeaderContainer": `Accordion-module__HeaderContainer__FfwPB`,
	"HeaderClickable": `Accordion-module__HeaderClickable__cek9U`,
	"HeaderContainerDisabled": `Accordion-module__HeaderContainerDisabled__XnlWa`,
	"Panel": `Accordion-module__Panel__zHBu2`,
	"PanelContent": `Accordion-module__PanelContent__m1ZDd`,
	"PanelCollapsed": `Accordion-module__PanelCollapsed__iZUIX`,
	"PanelExpanded": `Accordion-module__PanelExpanded__mQMop`
};
export default ___CSS_LOADER_EXPORT___;
